/* ==========================================================================
   Trendora theme JS: vanilla, no dependencies.
   Real Shopify cart via the Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js),
   predictive search, product variant picker, hero slider, countdown, filters.
   ========================================================================== */
(() => {
  "use strict";
  if (window.__trendora) return;
  window.__trendora = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const reduceMotion = () => matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Store config (from the header's data attributes) ---------- */
  const cfgEl = () => $("[data-tdr-header]") || $("[data-tdr-home]") || document.body;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const cfg = () => {
    const d = cfgEl().dataset;
    return {
      currency: d.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP",
      locale: d.locale || document.documentElement.lang || "en-GB",
      freeShipping: parseFloat(d.freeShipping || "0") || 0,
      cartUrl: d.cartUrl || root + "cart",
      addUrl: d.cartAddUrl || root + "cart/add",
      changeUrl: d.cartChangeUrl || root + "cart/change",
      searchUrl: d.searchUrl || root + "search/suggest",
    };
  };
  let moneyFmt;
  const money = (cents) => {
    if (!moneyFmt) {
      const c = cfg();
      try { moneyFmt = new Intl.NumberFormat(c.locale, { style: "currency", currency: c.currency }); }
      catch { moneyFmt = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }); }
    }
    return moneyFmt.format((Number(cents) || 0) / 100);
  };

  /* ---------- Toast + fun effects ---------- */
  const toastEl = () => {
    let t = $("[data-tdr-toast]");
    if (!t) { t = document.createElement("div"); t.className = "tdr-toast"; t.dataset.tdrToast = ""; t.setAttribute("role", "status"); document.body.appendChild(t); }
    return t;
  };
  const toast = (html) => {
    const t = toastEl();
    t.innerHTML = html; t.classList.add("is-show");
    clearTimeout(toast.timer); toast.timer = setTimeout(() => t.classList.remove("is-show"), 2800);
  };
  const burst = (x, y) => {
    if (reduceMotion()) return;
    const colors = ["#FF7A1A", "#F4436C", "#FFB400", "#0E1628"];
    for (let i = 0; i < 14; i++) {
      const p = document.createElement("span");
      const a = (Math.PI * 2 * i) / 14, dist = 40 + Math.random() * 40;
      p.className = "tdr-px";
      p.style.cssText = `left:${x}px;top:${y}px;background:${colors[i % 4]};--dx:${Math.cos(a) * dist}px;--dy:${Math.sin(a) * dist}px`;
      document.body.appendChild(p); setTimeout(() => p.remove(), 800);
    }
  };
  const flyToCart = (img) => {
    const target = $("[data-tdr-open='tdr-cart-drawer']");
    if (!img || !target || reduceMotion()) return;
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    const f = document.createElement(img.tagName === "IMG" ? "img" : "div");
    if (img.tagName === "IMG") f.src = img.currentSrc || img.src; else f.style.background = "#FFB070";
    f.className = "tdr-fly";
    f.style.left = a.left + a.width / 2 - 28 + "px"; f.style.top = a.top + a.height / 2 - 28 + "px";
    document.body.appendChild(f);
    requestAnimationFrame(() => {
      f.style.transform = `translate(${b.left + b.width / 2 - (a.left + a.width / 2)}px, ${b.top + b.height / 2 - (a.top + a.height / 2)}px) scale(.3)`;
      f.style.opacity = ".4";
    });
    setTimeout(() => f.remove(), 800);
  };

  /* ---------- Drawers ---------- */
  const openDrawer = (el) => {
    if (!el) return;
    el.classList.add("is-open"); el.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    const c = $("[data-tdr-close]", el); c && c.focus();
  };
  const closeDrawer = (el) => {
    el.classList.remove("is-open"); el.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  };
  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-tdr-open]");
    if (opener) {
      const dr = document.getElementById(opener.dataset.tdrOpen);
      if (dr) { e.preventDefault(); openDrawer(dr); if (dr.id === "tdr-cart-drawer") refreshCart(); }
      return;
    }
    const dr = e.target.closest(".tdr-drawer");
    if (dr && (e.target === dr || e.target.closest("[data-tdr-close]") || e.target.closest(".tdr-drawer__nav a"))) closeDrawer(dr);
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") $$(".tdr-drawer.is-open").forEach(closeDrawer); });

  /* ---------- Cart ---------- */
  const cartJSON = () => fetch(cfg().cartUrl + ".js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  const renderCart = (cart) => {
    const c = cfg();
    $$("[data-tdr-cart-count]").forEach((b) => (b.textContent = cart.item_count));
    const head = $("[data-tdr-cart-head]"); if (head) head.textContent = cart.item_count ? `(${cart.item_count})` : "";
    const sub = $("[data-tdr-cart-subtotal]"); if (sub) sub.textContent = money(cart.total_price);
    const msg = $("[data-tdr-ship-msg]"), fill = $("[data-tdr-ship-fill]");
    if (msg && fill) {
      const bar = msg.closest(".tdr-ship-bar");
      if (c.freeShipping > 0) {
        const left = c.freeShipping * 100 - cart.total_price;
        msg.innerHTML = left > 0 ? `You're <strong>${money(left)}</strong> away from free shipping` : `🎉 You've unlocked <strong>free shipping!</strong>`;
        fill.style.width = Math.min(100, (cart.total_price / (c.freeShipping * 100)) * 100) + "%";
      } else if (bar) bar.hidden = true;
    }
    const list = $("[data-tdr-cart-list]");
    if (!list) return;
    list.innerHTML = cart.items.length
      ? cart.items.map((it) => `
        <li class="tdr-cart-item">
          <a href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image)}${it.image.includes("?") ? "&" : "?"}width=160" alt="" loading="lazy">` : ""}</a>
          <div>
            <h4><a href="${esc(it.url)}">${esc(it.product_title)}</a></h4>
            ${it.variant_title && !it.product_has_only_default_variant ? `<span class="tdr-cart-item__variant">${esc(it.variant_title)}</span>` : ""}
            <div class="tdr-qty">
              <button type="button" data-tdr-qty="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button>${it.quantity}<button type="button" data-tdr-qty="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Increase">+</button>
            </div>
          </div>
          <strong>${money(it.final_line_price)}</strong>
        </li>`).join("")
      : `<li class="tdr-cart-empty"><p>Your cart is empty.<br>Let's find you something you'll love.</p><a class="tdr-btn tdr-btn--primary" href="${esc(root)}collections/all">Start shopping</a></li>`;
  };
  const refreshCart = () => cartJSON().then(renderCart).catch(() => {});

  const addToCart = (body, isForm) =>
    fetch(cfg().addUrl + ".js", {
      method: "POST",
      headers: isForm ? { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" } : { "Content-Type": "application/json", Accept: "application/json" },
      body: isForm ? body : JSON.stringify(body),
    }).then(async (r) => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.description || data.message || "Sorry, that couldn't be added.");
      return data;
    });

  const afterAdd = (btn, title, img) => {
    const r = btn.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2);
    flyToCart(img);
    refreshCart().then(() => {
      $$("[data-tdr-cart-count]").forEach((b) => { b.classList.remove("bump"); void b.offsetWidth; b.classList.add("bump"); });
    });
    toast(`<span>Added to cart: <strong>${esc(title)}</strong></span>`);
    if (!$("[data-tdr-open='tdr-cart-drawer']")) return;
    setTimeout(() => openDrawer(document.getElementById("tdr-cart-drawer")), 650);
  };

  document.addEventListener("click", (e) => {
    const add = e.target.closest("[data-tdr-add]");
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      addToCart({ items: [{ id: Number(add.dataset.tdrAdd), quantity: 1 }] })
        .then(() => afterAdd(add, add.dataset.tdrTitle || "Item", add.closest(".tdr-card, .tdr-dotd")?.querySelector("img, svg")))
        .catch((err) => toast(`<span>${esc(err.message)}</span>`))
        .finally(() => (add.disabled = false));
      return;
    }
    if (e.target.closest("[data-tdr-demo]")) {
      toast("<span>This is a demo product. Add products in Shopify admin and they'll appear here.</span>");
      return;
    }
    const q = e.target.closest("[data-tdr-qty]");
    if (q) {
      q.disabled = true;
      fetch(cfg().changeUrl + ".js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: q.dataset.tdrQty, quantity: Math.max(0, Number(q.dataset.q)) }),
      }).then((r) => r.json()).then(renderCart).catch(() => refreshCart());
      return;
    }
    const step = e.target.closest("[data-tdr-step]");
    if (step) {
      const input = step.parentElement.querySelector("input");
      if (input) {
        const min = Number(input.min || 0);
        input.value = Math.max(min, (Number(input.value) || 0) + Number(step.dataset.tdrStep));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  });

  /* ---------- Product page: AJAX add + variant picker + gallery ---------- */
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (form.id !== "tdr-product-form" || !window.fetch) return;
    e.preventDefault();
    const btn = $("[data-tdr-add-btn]", form);
    btn && (btn.disabled = true);
    addToCart(new FormData(form), true)
      .then(() => afterAdd(btn || form, $(".tdr-product__title")?.textContent.trim() || "Item", $("#tdr-main-img") || $(".tdr-product__main svg")))
      .catch((err) => toast(`<span>${esc(err.message)}</span>`))
      .finally(() => { if (btn) btn.disabled = btn.dataset.soldOut === "true"; });
  });
  document.addEventListener("change", (e) => {
    const sel = e.target.closest("[data-tdr-variant-select]");
    if (sel) {
      const o = sel.selectedOptions[0];
      const price = Number(o.dataset.price), compare = Number(o.dataset.compare), available = o.dataset.available === "true";
      const box = $(".tdr-product__info [data-tdr-price]");
      if (box) box.innerHTML = `<span class="tdr-price__now">${money(price)}</span>` +
        (compare > price ? `<span class="tdr-price__was">${money(compare)}</span><span class="tdr-price__save">Save ${money(compare - price)}</span>` : "");
      const btn = $("[data-tdr-add-btn]");
      if (btn) { btn.disabled = !available; btn.dataset.soldOut = String(!available); $("span", btn).textContent = available ? "Add to cart" : "Sold out"; }
      const img = $("#tdr-main-img");
      if (img && o.dataset.img) { img.removeAttribute("srcset"); img.src = o.dataset.img; }
      const url = new URL(location.href); url.searchParams.set("variant", sel.value); history.replaceState({}, "", url);
      return;
    }
    const sort = e.target.closest("[data-tdr-sort] select");
    if (sort) sort.form.submit();
  });
  document.addEventListener("click", (e) => {
    const th = e.target.closest("[data-tdr-thumb]");
    if (!th) return;
    const img = $("#tdr-main-img");
    if (img) { img.removeAttribute("srcset"); img.src = th.dataset.tdrThumb; }
    $$("[data-tdr-thumb]").forEach((b) => b.classList.toggle("is-active", b === th));
  });

  /* ---------- Predictive search ---------- */
  const initSearch = (form) => {
    if (form.dataset.ready) return; form.dataset.ready = "1";
    const input = $("input[type=search]", form), list = $(".tdr-search__suggest", form);
    if (!input || !list) return;
    let t, ctrl;
    input.addEventListener("input", () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { list.hidden = true; return; }
      t = setTimeout(() => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        fetch(`${cfg().searchUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`, { signal: ctrl.signal })
          .then((r) => r.json())
          .then((data) => {
            const items = (data.resources && data.resources.results && data.resources.results.products) || [];
            const re = new RegExp(`(${q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "ig");
            list.innerHTML = items.length
              ? items.map((p) => `<li><a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="">` : ""}<span>${esc(p.title).replace(re, "<b>$1</b>")}</span><strong style="margin-left:auto">${isNaN(Number(p.price)) ? esc(p.price) : money(Math.round(Number(p.price) * 100))}</strong></a></li>`).join("") +
                `<li><a href="${esc(form.action)}?q=${encodeURIComponent(q)}&type=product"><span>See all results for “${esc(q)}” →</span></a></li>`
              : `<li style="padding:10px" class="tdr-muted">No matches for “${esc(q)}”</li>`;
            list.hidden = false;
          }).catch(() => {});
      }, 180);
    });
    document.addEventListener("click", (e) => { if (!form.contains(e.target)) list.hidden = true; });
  };

  /* ---------- Hero slider ---------- */
  const initSlider = (slider) => {
    if (slider.dataset.ready) return; slider.dataset.ready = "1";
    const slides = $$(".tdr-slide", slider), dots = $$(".tdr-slider__dots button", slider);
    const ms = Number(slider.dataset.interval) || 6000;
    slider.style.setProperty("--slide-ms", ms + "ms");
    let cur = 0, timer;
    const go = (i) => {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle("is-active", k === cur));
      slider.classList.toggle("on-light", slides[cur].classList.contains("tdr-slide--light"));
      dots.forEach((d, k) => { d.classList.remove("is-active"); d.setAttribute("aria-selected", k === cur); });
      if (dots[cur]) { void dots[cur].offsetWidth; dots[cur].classList.add("is-active"); }
      clearTimeout(timer);
      if (slides.length > 1) timer = setTimeout(() => !slider.classList.contains("is-paused") && go(cur + 1), ms);
    };
    slider.tdrGo = (id) => { const i = slides.findIndex((s) => s.dataset.blockId === id); if (i > -1) { slider.classList.add("is-paused"); go(i); } };
    dots.forEach((d, i) => d.addEventListener("click", () => go(i)));
    slider.addEventListener("mouseenter", () => { slider.classList.add("is-paused"); clearTimeout(timer); });
    slider.addEventListener("mouseleave", () => { slider.classList.remove("is-paused"); go(cur); });
    go(0);
  };

  /* ---------- Deal of the Day countdown ---------- */
  const initCountdown = (el) => {
    if (el.dataset.ready) return; el.dataset.ready = "1";
    const endHour = Number(el.dataset.endHour ?? 23);
    const out = { h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
    const pad = (n) => String(n).padStart(2, "0");
    const tick = () => {
      const now = new Date(), end = new Date(now);
      end.setHours(endHour, 59, 59, 999);
      if (end <= now) end.setDate(end.getDate() + 1);
      let t = Math.floor((end - now) / 1000);
      out.h.textContent = pad(Math.floor(t / 3600)); t %= 3600;
      out.m.textContent = pad(Math.floor(t / 60)); out.s.textContent = pad(t % 60);
    };
    tick(); setInterval(tick, 1000);
  };

  /* ---------- Filter tabs (by product tag / type) ---------- */
  const initTabs = (sec) => {
    if (sec.dataset.ready) return; sec.dataset.ready = "1";
    const tabs = $$(".tdr-tab", sec), cards = $$("[data-tdr-grid] .tdr-card", sec), empty = $("[data-tdr-empty]", sec);
    tabs.forEach((t) => t.addEventListener("click", () => {
      tabs.forEach((x) => { x.classList.toggle("is-active", x === t); x.setAttribute("aria-selected", x === t); });
      const f = t.dataset.filter; let shown = 0;
      cards.forEach((c) => {
        const tags = (c.dataset.tags || "").split(/\s+/);
        const ok = f === "all" || tags.some((tag) => tag === f || tag.startsWith(f) || f.startsWith(tag) && tag.length > 2);
        c.hidden = !ok; if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }));
  };

  /* ---------- Rails, reveals, sticky header, scroll progress ---------- */
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add("is-in"); io.unobserve(x.target); } }), { threshold: 0.12 })
    : null;

  const initSticky = () => {
    const hdr = $("[data-tdr-header]");
    const sec = hdr && hdr.closest(".shopify-section");
    if (!sec) return;
    const ticker = $(".tdr-ticker", hdr);
    sec.style.setProperty("--tdr-ticker-h", (ticker ? ticker.offsetHeight : 0) + "px");
    sec.classList.add("tdr-sticky-section");
  };
  let progress, headerEl;
  const onScroll = () => {
    headerEl = headerEl || $(".tdr-header");
    progress = progress || $(".tdr-scroll-progress");
    headerEl && headerEl.classList.toggle("is-scrolled", scrollY > 40);
    if (progress) {
      const max = document.documentElement.scrollHeight - innerHeight;
      progress.style.transform = `scaleX(${max > 0 ? scrollY / max : 0})`;
    }
  };
  addEventListener("scroll", onScroll, { passive: true });

  const init = (scope = document) => {
    $$("[data-tdr-search]", scope).forEach(initSearch);
    $$("[data-tdr-slider]", scope).forEach(initSlider);
    $$("[data-tdr-countdown]", scope).forEach(initCountdown);
    $$("[data-tdr-deals]", scope).forEach(initTabs);
    $$("[data-tdr-rail]", scope).forEach((rail) => {
      const sec = rail.closest("section");
      $$("[data-rail]", sec).forEach((b) => {
        if (b.dataset.ready) return; b.dataset.ready = "1";
        b.addEventListener("click", () => rail.scrollBy({ left: rail.clientWidth * 0.8 * Number(b.dataset.rail), behavior: "smooth" }));
      });
    });
    $$(".tdr-reveal:not(.is-in)", scope).forEach((el) => (io ? io.observe(el) : el.classList.add("is-in")));
    $$(".tdr-nav__all", scope).forEach((btn) => {
      if (btn.dataset.ready) return; btn.dataset.ready = "1";
      btn.addEventListener("click", () => { const open = btn.parentElement.classList.toggle("is-open"); btn.setAttribute("aria-expanded", open); });
    });
    $$("select[data-tdr-default]", scope).forEach((s) => { if (s.dataset.tdrDefault) s.value = s.dataset.tdrDefault; });
    initSticky(); onScroll();
  };
  document.addEventListener("click", (e) => { if (!e.target.closest(".tdr-nav__mega")) $$(".tdr-nav__mega.is-open").forEach((m) => m.classList.remove("is-open")); });

  const start = () => { moneyFmt = null; init(); if ($("[data-tdr-cart-list]")) refreshCart(); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  addEventListener("resize", initSticky);

  /* ---------- Theme editor support ---------- */
  document.addEventListener("shopify:section:load", (e) => { moneyFmt = null; headerEl = progress = null; init(e.target); });
  document.addEventListener("shopify:block:select", (e) => {
    const slider = e.target.closest("[data-tdr-slider]");
    if (slider && slider.tdrGo) slider.tdrGo(e.target.dataset.blockId);
  });
  document.addEventListener("shopify:block:deselect", (e) => {
    const slider = e.target.closest("[data-tdr-slider]");
    if (slider) slider.classList.remove("is-paused");
  });
})();
